import AbstractPolicy from "@/policies/Proposal/Product/ProductPolicy/AbstractPolicy";

export default class MailNotifyPolicy extends AbstractPolicy {

}
